module.exports = __webpack_public_path__ + "img/nav-home.c35e996e.svg";